import {get} from "aws-amplify/api";
import React, {useCallback, useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import LogReport from "../components/Reports/LogReport";
import {RingLoader} from "react-spinners";
import {useUser} from "../contexts/AuthContext";

const ReportPrivate = (props: any) => {
  const [data, setData] = React.useState({});
  const {id} = useParams<{id: string}>();
  const [loading, setLoading] = useState(true);
  const {user, isInitialized} = useUser();

  const getData = useCallback(async () => {
    try {
      setLoading(true);

      const params = {
        headers: {
          Authorization: user.jwtToken
        }
      };
      const userId: string = user.identityId as string;
      const {body} = await get({
        apiName: "app",
        path: `/report/${userId}/${id}`,
        options: params
      }).response;
      const result: any = await body.json();

      // Handle large files that return a pre-signed S3 URL
      if (result && typeof result === "object" && result.useSignedUrl && result.url) {
        //console.log(`Large file detected (${result.fileSizeMB}MB), fetching from S3...`);
        const s3Response = await fetch(result.url);
        const data = await s3Response.json();
        setData(data as any);
      } else {
        // Small files return data directly
        setData(result as any);
      }
    } catch {
      // Set empty data on error to trigger the error message in LogReport
      setData({});
    } finally {
      setLoading(false); // Ensure loading is set to false in finally block
    }
  }, [user.jwtToken, user.identityId, id]);

  // useEffect to call getData when the component mounts and auth is initialized
  useEffect(() => {
    if (isInitialized && user.authenticated && user.jwtToken) {
      getData();
    } else if (isInitialized && !user.authenticated) {
      // User is not authenticated, set empty data with auth flag
      setData({isAuthenticationRequired: true});
      setLoading(false);
    }
  }, [isInitialized, user.authenticated, user.jwtToken, getData]);

  return (
    <>
      {loading && (
        <div className="iconWrapper">
          <RingLoader color="#4682b4" size={80} loading={true} />
        </div>
      )}
      {!loading && (
        <LogReport {...data} {...props} isShareable={true} logId={id} isAuthenticated={user.authenticated} />
      )}
    </>
  );
};

export default ReportPrivate;
